<template>
  <Tab @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #toolbar-items>
      <!-- ------------------------ notifications ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'list'"
        icon="fa-bell"
        name="list"
      ></TabToolbarButton>
    </template>
    <template #container>
      <!-- ------------------------ sites ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="manager/notifications/page" name="list">
        <template #content>
          <v-btn style="position: absolute;right: 20px; top: 10px;" :title="$t('dashboard.refresh')" icon @click="fetchNotifications">
            <v-icon x-small>
              fa-sync-alt
            </v-icon>
          </v-btn>
          <v-container>
            <v-list>
              <!-- Scrollable list of notifications -->
              <v-list-item-group style="max-height: calc(100vh - 292px);overflow-y: auto;">
                <div v-for="notification in notifications" :key="notification.id">
                  <v-list-item>
                    <v-list-item-content @click="NotificationsClick(notification)">
                      <div>
                        <v-chip v-if="notification.status>1" color="red lighten-2" x-small>Non lu</v-chip>
                        <v-chip v-else color="green lighten-2" x-small>lu</v-chip>
                        <v-chip color="grey lighten-2" x-small> {{ notification.created_at | moment("from") }}</v-chip>
                        <div class="mt-2">{{ notification.message }}</div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-item-group>
            </v-list>
            <div v-if="notifications.length <= 0">Vous n'avez pas notifications pour le moment</div>
          </v-container>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"

export default {
  name: "Websites",
  mixins: [tab],
  data: () => ({
    removeDialog: false,
    pages: ["list"],
    page: "list",
    menu: "notifications",
    notifications: [],
  }),
  mounted() {
    this.fetchNotifications()
  },
  methods: {
    fetchNotifications() {
      this.notifications = []
      this.$axios.get("/office/common/notifications").then(response => {
        this.notifications.push(...response.data)
      })
    },
    NotificationsClick(notification) {
      if(notification.status>1) {
        this.seenNotification(notification);
      } else {
        this.unSeenNotification(notification);
      }
    },
    seenNotification(notification) {
      notification.status = 1
      this.$axios.get("/office/common/notifications/seen/"+notification.id)
    },
    unSeenNotification(notification) {
      notification.status = 2
      this.$axios.get("/office/common/notifications/unseen/"+notification.id)
    },
  },
}
</script>
